/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuarantorMinimalDto
 */
export interface GuarantorMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof GuarantorMinimalDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorMinimalDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorMinimalDto
     */
    civilityId: string;
    /**
     * 
     * @type {string}
     * @memberof GuarantorMinimalDto
     */
    employmentStatusId: string;
    /**
     * 
     * @type {number}
     * @memberof GuarantorMinimalDto
     */
    monthlyAverageIncome: number;
    /**
     * 
     * @type {number}
     * @memberof GuarantorMinimalDto
     */
    rentToIncomeRatio: number;
}

/**
 * Check if a given object implements the GuarantorMinimalDto interface.
 */
export function instanceOfGuarantorMinimalDto(value: object): value is GuarantorMinimalDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('employmentStatusId' in value) || value['employmentStatusId'] === undefined) return false;
    if (!('monthlyAverageIncome' in value) || value['monthlyAverageIncome'] === undefined) return false;
    if (!('rentToIncomeRatio' in value) || value['rentToIncomeRatio'] === undefined) return false;
    return true;
}

export function GuarantorMinimalDtoFromJSON(json: any): GuarantorMinimalDto {
    return GuarantorMinimalDtoFromJSONTyped(json, false);
}

export function GuarantorMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuarantorMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'civilityId': json['civilityId'],
        'employmentStatusId': json['employmentStatusId'],
        'monthlyAverageIncome': json['monthlyAverageIncome'],
        'rentToIncomeRatio': json['rentToIncomeRatio'],
    };
}

export function GuarantorMinimalDtoToJSON(json: any): GuarantorMinimalDto {
    return GuarantorMinimalDtoToJSONTyped(json, false);
}

export function GuarantorMinimalDtoToJSONTyped(value?: GuarantorMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'civilityId': value['civilityId'],
        'employmentStatusId': value['employmentStatusId'],
        'monthlyAverageIncome': value['monthlyAverageIncome'],
        'rentToIncomeRatio': value['rentToIncomeRatio'],
    };
}

